import React, { Component } from 'react'
import styled from 'styled-components'
import { Button, Modal } from 'advenio-components'
import ExtraCharge from '../Activity/ExtraCharge'

const RadioGroupContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 100%;
  margin-top: 30px;
`
export const Check = styled.img`
    width: 20px;
    height: 20px;
    cursor: pointer;
    margin-right: 10px;
`
const Continue = styled.div`
  width: 100%;
  height: 80px;
  background-color: #fff;
  visibility: ${props => props.complete ? 'visible' : 'hidden'};
  justify-content: center;
  align-items: center;
  display: flex;
  position: absolute;
  bottom: 0px;
`
const SaveContainer = styled.div`
 width: 100%;
 height: 120px;
 background-color: transparent;
 justify-content:flex-end;
 align-items: center;
 display: flex;
`

const Container = styled.div`
  height: 50px;
  width: 230px;
  position: relative;
  overflow: hidden;
  display: flex;
  cursor: pointer;
  background-color: ${props => props.isSelected ? '#3b99fc' : '#FFFFFF'};
  margin-left: 10px;
  margin-right: 10px;
  margin-bottom: 10px;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  border-radius: 5px;
  border: solid 1px #CCCCCC;
`
const Buttons = styled.button`
  color: ${props => props.isSelected ? '#FFF' : '#4A4A4A'};
  background-color: transparent;
  padding: 8px 20px;
  height: 100%;
  width: 100%;
  cursor: pointer;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: row;
  border: solid 0.5px transparent;
`
const Input = styled.input`
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
  height: 100%;
  width: 100%;
  cursor: pointer;
  opacity: 0;
`

class RadioGroupMeal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      selected: null,
      isComplete: false,
      open: false,
      width: 0,
    }
  }

  componentDidMount() {
    this.updateWindowDimensions()
    window.addEventListener('resize', this.updateWindowDimensions)
  }

  componentWillMount() {
    if (this.props.selected !== '') {
      this.setState({ isComplete: true })
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions)
  }


  onClick = (e) => {
    const name = e.target.name
    const id = e.target.id
    if (e.target.id !== '') {
      const { info } = this.props
      this.setState({
        selected: e.target.id,
        isComplete: !!info.drink,
      },
      () => this.props.setInfo(id, name))
    }
  }

  closeModal = () => {
    this.setState({open:false})
  }

  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth })
  }



  render() {
    const children = this.props.children
    return (
      <RadioGroupContainer>
        {
          children.map((currentValue, index, array) => {
            const selected = this.state.selected !== null ? (this.state.selected == currentValue.props.label) : (this.state.selected == currentValue.props.label)  || (this.props.selected === currentValue.props.label )
            return (
              <Container key={index} isSelected={selected} >
                <Input
                  ref={(input) => this.clickItem = input}
                  onClick={this.onClick}
                  id={currentValue.props.label}
                  name={currentValue.props.name}
                  type="radio"
                />
                <Buttons onClick={() => this.clickItem.click()} isSelected={selected}>
                  <Check
                    src={selected ? "/assets/radiochecked.svg" : "/assets/radiocheckmark.svg" }
                    checked={this.state.selected == currentValue.props.label}/>
                  {currentValue.props.type}
                </Buttons>
              </Container>
            )
          })}
        {this.props.group ?
          <Continue complete={this.state.isComplete}>
            <Button
              small
              style={{ backgroundColor: '#4A90E2', color: '#FFF', flex: '1' }}
              onClick={() => this.props.goToView('selectKids', '','')}
            >
            Continuar
            </Button>
          </Continue>
          :
          <SaveContainer>
            <Button
              small
              style={this.state.isComplete ? {backgroundColor:'#3E72D7',color:'#FFF'} : {backgroundColor:'#CCCCCC',color:'#FFF'} }
              onClick={() => this.props.goToView('extraCharge','',this.props.category)}
            >
            Continuar
            </Button>
          </SaveContainer>
        }
      </RadioGroupContainer>
)
}
}

export default RadioGroupMeal



// WEBPACK FOOTER //
// ./src/Components/CustomButtons/RadioGroupMeal.jsx